import React, { useState, useEffect } from 'react';
import { Column, Row } from 'components/Layout/Grid';
import Text from 'components/Text';
import BrandServices from 'services/brand.service';
import Select from 'components/Select';
import { IOption } from 'components/Select/interface';
import { BrandSimpleProps } from './interface';

export const BrandSimple: React.FC<BrandSimpleProps> = (props) => {
  const { brandSelected, setBrandSelected, setNameBrandSelected } = props;
  const [brandOption, setBrandOption] = useState(Array<IOption>());

  const _brandServices = new BrandServices();

  const getBrands = async () => {
    const response = await _brandServices.get(undefined, undefined, 'name asc', {
      and: [
        { enable: { eq: true } },
        { enterpriseCode: { in: [997, 998, 999] } }
      ]
    });

    const { data } = response;

    if (data) {
      const _brandOption: Array<IOption> = new Array<IOption>();
      Object.keys(data).forEach((key) => {
        _brandOption.push({
          value: data[key].id,
          label: data[key].name,
          enterpriseCode: parseInt(data[key].enterpriseCode)
        });
      });

      setBrandOption(_brandOption);
    }
  };

  const handleSetBrandSelected = (value: string) => {
    setBrandSelected(value);

    const nameSubsidiary: string = brandOption.find((brand: IOption) => brand.value === value)?.label || "";
    setNameBrandSelected(nameSubsidiary);
  };

  useEffect(() => {
    getBrands();
  }, []);

  return (
    <Row className="flex-md-column">
      <Column className="flex-1 mt-5">
        <Text className="mb-2 color-blue-gray" size={12}>
          Empresas Viveo
        </Text>
        <Select
          id='brandSimple'
          data-testid="brandSimple"
          data-statename="brandSimple"
          required
          name="Marca"
          value={brandSelected}
          onChange={(e) => handleSetBrandSelected(e.target.value)}
          className="w-lg-100"
          width={'240px'}
          options={brandOption}
        />
      </Column>
    </Row>
  );
};